import { CurrencyPipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'
import { PlatformSettingsService } from '@app/core/services/platfrom-settings.service'
import { Currency } from '../models/currency.model'

@Pipe({
  name: 'platformCurrency',
  standalone: false,
})
export class PlatformCurrencyPipe extends CurrencyPipe implements PipeTransform {
  currency: Currency

  constructor(private readonly platformSettingsService: PlatformSettingsService) {
    super('en')
    this.currency = platformSettingsService.getClientCurrency()
  }

  transform(value: number | string | null | undefined): null
  transform(
    value: number | string,
    currencyCode = this.currency.symbol,
    display = 'code',
    digitsInfo = `1.${this.currency.decimals}-${this.currency.decimals}`,
  ): string | null {
    return super.transform(value, currencyCode, display, digitsInfo)
  }
}
